<template>
	<div class="tags" v-if="showTags" ref="tags">
		<span v-show="leftRightbtnFlag" class="el-icon-arrow-left span-btn" @click="leftbtnClick"></span>
		<div class="tags-ul-div" ref="ulDiv">
			<div style="display: inline-block;">
				<!-- 需要一个无宽度得div -->
				<ul ref="ul">
					<li ref="li" class="tags-li" v-for="(item,index) in tagsList" :class="{'active': isActive(item.path)}" :key="index">
				        <router-link :to="item.path" :key="index" class="tags-li-title">
						{{item.title}}
				        </router-link>
				        <span class="tags-li-icon" @click="closeTags(index)"><i class="el-icon-close"></i></span>
				    </li>
				</ul>
			</div>
		</div>

		<span v-show="leftRightbtnFlag"  @click="rightbtnClick" class="el-icon-arrow-right span-btn"></span>

		<div class="tags-close-box">
			<el-dropdown @command="handleTags">
				<el-button size="mini" type="primary">
					{{tags.tags_0}} <i class="el-icon-arrow-down el-icon--right"></i>
				</el-button>
				<el-dropdown-menu size="small" slot="dropdown">
					<el-dropdown-item command="other">{{tags.tags_1}}</el-dropdown-item>
					<el-dropdown-item command="all">{{tags.tags_2}}</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
		</div>
	</div>
</template>

<script>
	import bus from './bus';
	export default {
		inject: ['reload'], //在子组件中通过inject调用
		data() {
			return {
				tagsList: [],
				leftRightbtnFlag: false,
				tags: {
					tags_0: "标签选项",
					tags_1: "关闭其他",
					tags_2: "关闭所有"
				}
			}
		},
		methods: {
			isActive(path) {
				return path === this.$route.fullPath;
			},
			// 关闭单个标签
			closeTags(index) {

				// 如果是最后一个tags并且是首页，就不可以点击了
				if (this.COMM.tagsLists.length === 1 && this.$route.fullPath === '/dashboard') {
					return;
				}
				if (this.COMM.tagsLists.length === 1 && this.$route.fullPath === '/agentDashboard') {
					return;
				}
				if (this.COMM.tagsLists.length === 1 && this.$route.fullPath === '/shopDashboard') {
					return;
				}
				const delItem = this.COMM.tagsLists.splice(index, 1)[0];
				const item = this.COMM.tagsLists[index] ? this.COMM.tagsLists[index] : this.COMM.tagsLists[index - 1];
				
				if (item) {
					delItem.path === this.$route.fullPath && this.$router.push(item.path);
					this.tagsList = this.COMM.tagsLists;
					
					if (this.leftRightbtnFlag) {
						this.$nextTick(()=>{
							this.judgeWidth();
						})
					}
					
				} else {
					if(this.$router.resolve({name: 'Dashboard'}).route.matched.length !== 0){
						this.$router.push('/dashboard');
					} else if (this.$router.resolve({name: 'agentDashboard'}).route.matched.length !== 0){
						this.$router.push('/agentDashboard');
					}else if(this.$router.resolve({name: 'shopDashboard'}).route.matched.length !== 0){
						this.$router.push('/shopDashboard');
					}
					this.reload();
				}
				//this.$bus.$emit('change') 
			},
			// 关闭全部标签
			closeAll() {
				this.COMM.tagsLists = [];
				this.tagsList = this.COMM.tagsLists;
				// this.$router.push('/');
				if(this.$router.resolve({name: 'Dashboard'}).route.matched.length !== 0){
					this.$router.push('/dashboard');
				} else if (this.$router.resolve({name: 'agentDashboard'}).route.matched.length !== 0){
					this.$router.push('/agentDashboard');
				}else if(this.$router.resolve({name: 'shopDashboard'}).route.matched.length !== 0){
					this.$router.push('/shopDashboard');
				}
				this.reload();
			},
			// 关闭其他标签
			closeOther() {
				// this.SessionClose();
				const curItem = this.COMM.tagsLists.filter(item => {
					return item.path === this.$route.fullPath;

				})
				this.COMM.tagsLists = curItem;
				this.tagsList = this.COMM.tagsLists;
				if (this.leftRightbtnFlag) {
					this.$nextTick(()=>{
						this.judgeWidth();
					})
				}
				this.reload();
			},
			// 设置标签
			setTags(route) {
				
				const isExist = this.COMM.tagsLists.some(item => {
					return item.path === route.fullPath;
				})
				if (!isExist) {
					// if(this.COMM.tagsLists.length >= 8){
					//     this.COMM.tagsLists.shift();
					// }
					let obj = {
						title: route.meta.title,
						path: route.fullPath,
						name: route.matched[1].components.default.name
					};
					// 取得当前得数据
					let BAG = JSON.parse(sessionStorage.getItem('ms_BAG'));
					BAG.forEach((team, index)=>{
						// 如果路由与数据匹配则使用当前title
						if (team.url.toLowerCase().indexOf(route.fullPath.toLowerCase()) !== -1) {
							obj.title = team.name;
						}
					});
					this.COMM.tagsLists.push(obj);
				}

				this.tagsList = this.COMM.tagsLists;
				bus.$emit('tags', this.tagsList);
				this.$set(this.tagsList);
				
				// 页面发生渲染时，进行回调
				this.$nextTick(()=>{
					// 判断宽
					this.judgeWidth();
					
					//显示按钮之后回调
					this.$nextTick(()=>{
						// 使光标移动到当前位置
						let li = this.$refs.li; //获取所有li标签数组
						let activeLi = li.filter((team)=> { // 获取选择的li标签位置
							return team.className.includes('active');
						})[0];
						// 计算 scrollbar 需要移动的位置
						this.$refs.ulDiv.scrollLeft = activeLi.offsetLeft - (parseInt(window.getComputedStyle(activeLi).width)/2);
					})
				})
			},
			handleTags(command) {
				command === 'other' ? this.closeOther() : this.closeAll();
			},
			// 语言改变时，已添加得tags，语言变更
			changeLanguage(data) {
				this.tagsList.forEach((team, index)=>{
					let path = team.path.toLowerCase();
					if (path.indexOf('?') !== -1) {
						path = team.path.toLowerCase().split('?')[0];
					}
					
					data.forEach((tem,ind)=>{
						if (tem.url.toLowerCase().indexOf(path) !== -1) {
							team.title = tem.name;
						}
					})
				})
			},
			// 左侧按钮点击事件
			leftbtnClick () {
				this.$refs.ulDiv.scrollLeft += -50;
			},
			// 右侧按钮点击事件
			rightbtnClick () {
				this.$refs.ulDiv.scrollLeft += 50;
			},
			// 监听scroll事件判断有无按钮
			ulScroll () {
				this.judgeWidth();
			},
			// 添加监听方法
			mutationObserver () {
				// 添加浏览器窗口监听
				window.onresize = this.ulScroll;
			},
			judgeWidth () {
				let ulWidth = parseInt(window.getComputedStyle(this.$refs.ul).width);
				let divWidth = parseInt(window.getComputedStyle(this.$refs.ulDiv).width);
				
				if (ulWidth >= divWidth) {
					if (!this.leftRightbtnFlag) {
						this.leftRightbtnFlag = true;
					}
				} else {
					this.leftRightbtnFlag = false;
				}
			}
		},
		computed: {
			showTags() {
				return this.tagsList.length > 0;
			}
		},
		watch: {
			$route(newValue, oldValue) {
				this.setTags(newValue);
			}
		},
		created() {
			
			this.setTags(this.$route);
			// 监听关闭当前页面的标签页
			bus.$on('close_current_tags', () => {
				for (let i = 0, len = this.COMM.tagsLists.length; i < len; i++) {
					const item = this.COMM.tagsLists[i];
					if (item.path === this.$route.fullPath) {
						if (i < len - 1) {
							this.$router.push(this.COMM.tagsLists[i + 1].path);
						} else if (i > 0) {
							this.$router.push(this.COMM.tagsLists[i - 1].path);
						} else {
							if(this.$router.resolve({name: 'Dashboard'}).route.matched.length !== 0){
								this.$router.push('/dashboard');
							} else if (this.$router.resolve({name: 'agentDashboard'}).route.matched.length !== 0){
								this.$router.push('/agentDashboard');
							}else if(this.$router.resolve({name: 'shopDashboard'}).route.matched.length !== 0){
								this.$router.push('/shopDashboard');
							}
							this.reload();
						}
						this.COMM.tagsLists.splice(i, 1);
						break;
					}
				}
			})
			this.tagsList = this.COMM.tagsLists;
			this.$bus.$on('change', () => {
				//刷新当前页面
				this.reload();
			});
		},
		mounted () {
			this.mutationObserver();
		},
		beforeDestroy() {
		  window.removeEventListener("resize", this.echartsResize); // 通过有名函数 解除事件订阅
		}
	}
</script>
<style>
	.tags {
		height: 30px;
		overflow: hidden;
		background: #fff;
		box-shadow: 0 5px 10px #ddd;
		display: flex;
		justify-content: space-between;
	}

	.tags ul {
		box-sizing: border-box;
		height: 100%;
		display:flex;
		flex-wrap:nowrap;
	}

	.tags-li {
		flex-shrink:0;
		margin: 3px 7px 2px 1px;
		border-radius: 3px;
		font-size: 12px;
		overflow: hidden;
		cursor: pointer;
		height: 23px;
		line-height: 23px;
		border: 1px solid #e9eaec;
		background: #fff;
		padding: 0 5px 0 12px;
		vertical-align: middle;
		color: #666;
		-webkit-transition: all .3s ease-in;
		-moz-transition: all .3s ease-in;
		transition: all .3s ease-in;
	}

	.tags-li:not(.active):hover {
		background: #f8f8f8;
	}

	.tags-li.active {
		color: #fff;
	}

	.tags-li-title {
		float: left;
		max-width: 80px;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		margin-right: 5px;
		color: #666;
	}

	.tags-li.active .tags-li-title {
		color: #fff;
	}

	.tags-close-box {
		box-sizing: border-box;
		padding-top: 1px;
		text-align: center;
		width: 110px;
		height: 30px;
		background: #fff;
		box-shadow: -3px 0 15px 3px rgba(0, 0, 0, .1);
		z-index: 10;
		margin:0 3px 0 10px;
	}
	.tags-ul-div{
		display: inline-block;
		width: 100%;
		overflow-x: auto;
		overflow-y: hidden;
	}
	/*滚动条样式*/
	.tags-ul-div::-webkit-scrollbar {/*滚动条整体样式*/
		width: 3px;
		height: 3px;
	}
	.tags-ul-div::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
		border-radius: 5px;
		-webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
		background: rgba(0,0,0,0.2);
	}
	.tags-ul-div::-webkit-scrollbar-track {/*滚动条里面轨道*/
		-webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
		border-radius: 0;
		background: rgba(0,0,0,0.1);
	}
	
	.span-btn{
		display: inline-block;
		flex-shrink:0;
		margin: 3px 5px 2px 3px;
		font-size: 12px;
		cursor: pointer;
		height: 23px;
		line-height: 23px;
		background: #fff;
		padding: 0 5px 0 12px;
		color: #666;
	}
	.tags-ul-div{
		/*隐藏滚动条，当IE下溢出，仍然可以滚动*/
		-ms-overflow-style:none;
	}
</style>
